import React, { Fragment } from "react";
import DateTime from 'react-datetime'
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import Select, { Async } from 'react-select';
import 'react-select/dist/react-select.css';
import { toCurrency } from '../utility/number';
import ReactTable from "react-table";
import MobileGrid from "./MobileGrid";

var debounce = require('debounce-promise')
import { loginInfo, setLanguage, getCookie, logMessageToChatRoom } from '../global';
import {
  Button, ButtonGroup, Tooltip,
  Modal, ModalHeader, ModalBody, ModalFooter,
  ListGroup, ListGroupItem,
  InputGroup, InputGroupAddon, InputGroupText, Input,
  Card, CardHeader, CardBody,
  Row, Col,
  Collapse
} from 'reactstrap';

import { checkIsOffline, getOfflineData } from "../reactNativeListener";

export const getFieldIndex = function (field, index) {
  index = index === undefined ? '' : index;
  var result = `${field}${index}`;

  return result;
}

import 'nouislider';
import 'nouislider/distribute/nouislider.css';
import Popup from "./Popup";

export class Slider extends React.Component {

  constructor(props) {
    super(props);

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);

    this.state = {
      value: props.values[name],
    }
  }


  handleChange = text => {

    this.setState({
      value: text
    });
    var name = this.props.name;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    if (this.props.onChange) {
      this.props.onChange();
    }

  };

  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
      this.refresh(nextState.value);
    }


    return false;
  }

  componentDidMount() {
    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;


    noUiSlider.create(this.nameInput, {
      start: this.props.start,
      // tooltips: true,
      step: this.props.step,
      connect: true,
      range: {
        'min': this.props.min,
        'max': this.props.max,
      }
    });

    this.nameInput.noUiSlider.on('update', values => {
      var result = values.map(obj => parseFloat(obj).toFixed(0));
      this.refreshLabel(result);
      this.handleChange(result);

    });

  }

  refreshLabel(value) {
    this.valueDiv.innerHTML = value.join(' - ');
  }

  refresh(value) {
    if (!value) value = [this.props.min, this.props.max];
    this.nameInput.noUiSlider.set(value);
  }


  render() {

    ////console.log("==========Slier Render==========");

    return (
      <Fragment>
        <div className="SliderContainer" style={{ marginLeft: "16px", marginRight: "16px" }} ref={(input) => {
          this.nameInput = input;
        }}></div>
        <div className="mt-1" ref={(input) => {
          this.valueDiv = input;
        }}></div>
      </Fragment>
    );
  }
}

const selectAllContent = (event) => {
  event.target.select();
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function waitAjax() {
  if (ajaxCallComplete === 2) return Promise.resolve(null);
  else return delay(100).then(() => {
    return waitAjax();
  });
}

function waitAndCallAjax(currentCount) {

  //Double check all the function call is gather
  if (GeneralMasterAjaxCount != 0) return delay(100).then(() => {
    return waitAndCallAjax(currentCount);
  });

  //skip all the request except the last one
  if (ajaxCallComplete == 1 || currentCount != lastCount) return waitAjax();

  //call ajax in the last function call
  ajaxCallComplete = 1;

  return fetch(`${window.host}/FB.GetBatchGeneralMaster`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      session: loginInfo.Session, Ledger: loginInfo.Ledger, Language: loginInfo.language,
      BatchData: JSON.stringify(batchData)
    }),
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  }).then((response) => {
    return response.json();
  });
}

// delay(3000).then(() => alert('runs after 3 seconds'));

export const selectDict = {};
export const newSelectDict = {};

var GeneralMasterAjaxCount = 0;
var batchData = [];
var lastCount = 0;
// var lastTimestamp, startTimestamp;
// var currentCount = 0;
var ajaxCallComplete = 0;

const getGeneralMaster = (input, module, table, name, label, createAble, updateLabel, filter, localData) => {



  if (ajaxCallComplete === 1) {
    return delay(100).then(() => getGeneralMaster(input, module, table, name, label, createAble, updateLabel, filter, localData))
  }


  filter = filter || {};
  var dataObj = { Table: table, Input: input, session: loginInfo.Session, Ledger: loginInfo.Ledger, Language: loginInfo.language, ...filter, filters: JSON.stringify(filter), name: name, label: label };
  // let data = JSON.stringify(dataObj);
  let fetchPromise;

  //if it is offline and with local data in Kiosk
  //get local data from kiosk
  //var localDataInKiosk
  //fetchPromise = Promise.resolve(localDataInKiosk);
  //fetchPromise = Promise.resolve([{ Code: '1', Desc: 'Bin123' }]);

  let isOffline = checkIsOffline();
  var localDataInKiosk;
  if (!localData) {

    //Added by Ning 
    //return null if table name is empty
    if (!table)
      return Promise.resolve(null);

    if (window.isReactNative && isOffline) {
      let tmpKey = `${window.host}/${module || window.masterModule || 'FB'}.RefreshTableList-${table}`;
      fetchPromise = getOfflineData(tmpKey).then(offlineData => {
        if (offlineData != null) {
          localDataInKiosk = JSON.parse(offlineData).options;
          if (input)
            localDataInKiosk = localDataInKiosk.filter(dataObj => dataObj.value.includes(input) || dataObj.label.includes(input));
        }
        else {
          localDataInKiosk = [];
        }
        return Promise.resolve(localDataInKiosk);
      })
    }
    else {

      if (GeneralMasterAjaxCount == 0) {
        batchData.length = 0;
        lastCount = 0;
        // startTimestamp = Date.now();
        ajaxCallComplete = 0;


        // //reset pulldown cache
        // for (var pro in newSelectDict) {
        //   delete newSelectDict[pro];
        // }

      }

      var currentCount = ++GeneralMasterAjaxCount;
      lastCount = currentCount;
      batchData.push(dataObj);
      // lastTimestamp = Date.now();



      //console.log(`fetchPromise.then GeneralMasterAjaxCount++ ${table}`, 300 - (lastTimestamp - startTimestamp))


      //group ajax within 300 ms
      // fetchPromise = delay(300 - (lastTimestamp - startTimestamp)).then(() => {

      fetchPromise = delay(300).then(() => {
        GeneralMasterAjaxCount--;

        return waitAndCallAjax(currentCount);

      });

    }

  }
  else {
    // var tmplocalData = [];
    // localData.forEach(element => {
    //   if (element.label.toUpperCase().includes(input.toUpperCase()))
    //     tmplocalData.push(element);
    // })

    // console.log('localData', localData)
    // let tmpJson = localData.map(obj => ({ Code: obj.value.ProductCode, Desc: obj.value.ProductDesc }));
    // let tmpJson = localData.map(obj => ({ Code: obj.value.ProductCode, Desc: obj.value.ProductDesc, value: obj.value }));

    var tmpLocalData = input ? localData.filter(dataObj => dataObj.value.includes(input) || dataObj.label.includes(input)) : localData;

    let tmpJson = tmpLocalData.map(obj => ({ Code: obj.value, Desc: obj.label, ...obj }));

    fetchPromise = Promise.resolve(tmpJson);
  }



  // console.log("===============localData===============", localData);

  return fetchPromise.then((oriJson) => {

    var json = oriJson;

    if (!selectDict[table])
      selectDict[table] = {};


    if (localData) {
      json.forEach(element => {
        selectDict[table][element.value] = element;
      });

      return { options: json };
    }

    if (json) {
      if (json.Code) {

        json.forEach(element => {
          if (localData)
            element.value = typeof (element.value) == "object" ? JSON.stringify(element.value) : element.value;
          else
            element.value = element.Code;

          element.label = element.Desc || element.Code;
          selectDict[table][element.value] = element;
        });

      }
      else {

        Object.keys(json).forEach(key => {

          //reset the pull down item when get the new master data from server
          newSelectDict[key] = {};
          json[key].forEach(element => {
            if (!selectDict[key]) selectDict[key] = {};

            element.value = element.Code;
            element.label = element.Desc || element.Code;

            selectDict[key][element.value] = element;
            newSelectDict[key][element.value] = element;
          });


        });
        ajaxCallComplete = 2;
      }

    }


    if (json && json[table]) {
      json = json[table];
    }
    else if (newSelectDict[table]) {
      json = Object.values(newSelectDict[table]);
    }



    if (createAble && input) {
      if (!selectDict[table][input]) {
        selectDict[table][input] = { value: input, label: input };
      }

      // Insert if value not found in server
      var index = json.findIndex(x => x.value == selectDict[table][input].value);
      if (index == -1)
        json.splice(0, 0, { value: input, label: input });
    }

    if (updateLabel)
      setTimeout(() => {
        updateLabel();
      }, 1);

    console.log(`check return ${table} json: `, json);
    return { options: json };
  });
}

export class AsyncSelectField extends React.Component {
  render() {
    var useNative = (window.isTablet) && this.props.clearable == false;
    // var useNative = this.props.clearable == false;
    if (this.props.multi)
      return <MultiSelectField {...this.props} ></MultiSelectField>;

    // if (useNative)
    //   return <NativeSelectField {...this.props} ></NativeSelectField>;
    if (window.isTablet) {
      if (this.props.clearable)
        return <NativeSelectField {...this.props} ></NativeSelectField>;
      else
        return <MobileSelectField {...this.props} />
    }
    else
      return <CustomcSelectField {...this.props} ></CustomcSelectField>;
  }
}

class MultiSelectField extends React.Component {

  constructor(props) {
    super(props);
    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);
    this.shouldUpdate = false;
    this.separator = props.separator;

    var value;
    if (this.separator) value = (props.values[name] || "").split(';');
    else value = props.values[name];

    this.state = {
      value: value,
      error: props.errors[this.nameIndex],
    }
  }

  //Code to clear the cache==== Start
  cache = {}
  purgeCache = () => {

    Object.keys(this.cache).forEach(entry => {
      // //console.log("entry",entry);
      // //console.log("this.cache[entry]",this.cache[entry]);
      // //console.log("this.cache",this.cache);
      // //console.log("selectDict", selectDict);
      delete this.cache[entry]
    })

    this.nameInput.loadOptions("");
  }
  //==== End

  handleChange = (value) => {

    if (this.props.setFieldValue) {
      let valueToPassed;
      if (this.separator) valueToPassed = (value || []).map(obj => obj.Code).join(";");
      else valueToPassed = value;
      this.props.setFieldValue(this.props.name, valueToPassed, this.props.index);
    }

    this.setState(value);

    if (this.props.onChange)
      this.props.onChange(value);
  };

  getFilter() {
    // ////console.log(filterKeys);
    let filterKeys = this.props.filterKeys || [];
    let values = this.props.values;
    var filter = {};
    filterKeys.forEach(key => {
      filter[key] = values[key];
    });
    return filter;

  }

  handleBlur = (event) => {

    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    //clear cache
    if (nextProps.isAfterSave && nextProps.isAfterSave()) {
      this.purgeCache();
    }

    var shouldUpdate = this.shouldUpdate;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];

    if (shouldUpdate) {
      this.shouldUpdate = false;
      return true;
    }
    return shouldUpdate;
  }

  getOptions = (input) => {

    return getGeneralMaster(input, this.props.module, this.props.tableName, this.props.name, this.props.label, this.props.createAble, this.props.updateLabel, this.getFilter(), this.props.localData);
  }

  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();

    if (this.props.values && name) {
      if (this.props.localData) {

      } else {

          this.getOptions(this.props.values[name]).then(response => {
          var defaultDict = response.options;

          var defalutValue = this.state.value ? defaultDict.find(obj => {
            return obj.Code == this.state.value
          }) : undefined;

          if (this.props.values[name]) {
            this.props.values[name] = [];
            this.props.values[name].push(defalutValue);
          }
          this.setState({});
        })
      }
    }
  }

  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }


  render() {
    //////console.log(`async select ${this.props.name}`);
    //////console.log(this.cache);

    const {
      tableName,
      multi,
      name,
      values, errors, validateFieldValue, isSubmitted, formComponents,
      setFieldValue,
      setFieldTouched,
      getFormData,
      disabled,
    } = this.props;



    // var value = this.state.value || [];

    let value;
    if (this.separator && !Array.isArray(this.state.value)) value = (this.state.value || "").split(";");
    else value = this.state.value || [];

    console.log(`multi- value: ${value} , separator: ${this.separator}, selectDict: ${selectDict[tableName]}`);
    // value = selectDict[tableName] || [];

    const error = isSubmitted ? this.state.error : '';

    console.log("test", this.props)

    return (
      <div className={error && "is-invalid"}>

        <Async
          className="Select-tag-control"
          clearable={this.props.clearable}
          tabIndex={this.props.tabIndex}
          placeholder={this.props.placeholder || "Please select"}
          cache={this.cache}
          ignoreCase={false}
          ref={(input) => {
            this.nameInput = input;
          }}
          // filterOptions={(options, filter, current_values) => { return options; }}
          filterOption={() => (true)}
          loadOptions={debounce(this.getOptions, 300)}
          multi={this.props.multi}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={value}
          searchable={!this.props.notSearchable}
          disabled={!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view')}
        />

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class CustomcSelectField extends React.Component {

  constructor(props) {
    super(props);
    var name = props.name;
    var index = props.index;
    var refreshLabel = props.refreshLabel;

    this.nameIndex = getFieldIndex(name, index);
    this.shouldUpdate = false;

    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      isToolTipOpen: false,
      input: "",
    }

    this.maxLength = props.maxLength || 524288;
  }

  //Code to clear the cache==== Start
  cache = {}
  purgeCache = () => {

    Object.keys(this.cache).forEach(entry => {
      // //console.log("entry",entry);
      // //console.log("this.cache[entry]",this.cache[entry]);
      // //console.log("this.cache",this.cache);
      // //console.log("selectDict", selectDict);
      delete this.cache[entry]
    })

    this.nameInput.loadOptions("");
  }
  //==== End

  handleChange = (value, par1, par2) => {

    value = value || {
      value: undefined,
      label: undefined,
    };


    if (this.props.getFormData) {
      this.state = {};
      var filterValues = {};
      if (this.props.filterKeys)
        this.props.filterKeys.forEach(x => {
          filterValues[x] = this.props.values[x];
        });
      this.props.getFormData({ ...filterValues, Code: value.value, [this.props.name]: value.value });
    } else {
      if (this.props.setFieldValue) {
        this.props.setFieldValue(this.props.name, value.value, this.props.index, value.label);
      }






      this.setState(value);

    }
    // if(this.props.refreshLabel)
    this.pushLabelToValue(value);

    if (this.props.onChange)
      this.props.onChange(value);
  };

  pushLabelToValue(value) {
    const { customProps } = this.props;
    const { values } = this.props;
    const { label } = this.props;
    if (customProps && customProps.fieldLabelPair && this.props.name && customProps.fieldLabelPair[this.props.name])
      values[customProps.fieldLabelPair[this.props.name]] = value.label;
    else {
      if (!values[label])
        values[label] = value.label;
    }
  }


  getFilter() {
    // ////console.log(filterKeys);
    let filterKeys = this.props.filterKeys || [];
    let values = this.props.values;
    var filter = {};
    filterKeys.forEach(key => {
      filter[key] = values[key];
    });
    return filter;

  }

  handleBlur = (event) => {

    if (this.props.onBlur) {
      this.props.onBlur();



    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    //clear cache
    if (nextProps.isAfterSave && nextProps.isAfterSave()) {
      this.purgeCache();
    }

    var shouldUpdate = this.shouldUpdate;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    // else if (this.props.showTooltip && nextState.isToolTipOpen != this.state.isToolTipOpen)
    //   shouldUpdate = true;

    nextState.error = nextProps.errors[this.nameIndex];

    if (shouldUpdate) {
      this.shouldUpdate = false;
      return true;
    }
    return shouldUpdate;
  }

  getOptions = (input, callback) => {
    return getGeneralMaster(input, this.props.module, this.props.tableName, this.props.name, this.props.label, this.props.createAble, this.updateLabel, this.getFilter(), this.props.localData);
  }

  updateLabel = () => {
    //////console.log("start updateLabel");
    var tableName = this.props.tableName;
    var value = this.state.value;

    if (!value || !tableName
      || (selectDict[tableName][value] && this.state.label == selectDict[tableName][value].label)) return;

    // console.log(`an UpdateLabel ${tableName} [${value}]`);

    this.shouldUpdate = true;
    this.setState({});
    //////console.log("updateLabel end");
  }

  getLabel(value) {
    var defaultLabel = this.props.placeholder || "Please select";
    var label = LabelMapping[defaultLabel] || defaultLabel;
    var tableName = this.props.tableName;

    if (value
      && selectDict[tableName]
      && selectDict[tableName][value]) {
      label = selectDict[tableName][value].label;
    }
    else if (value && this.props.label) {
      label = this.props.values[this.props.label] || defaultLabel;
    }


    return label;
  }

  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();

    // console.log("name: ", name)

    // if (this.props.values && name) {
    //   if (this.props.localData) {

    //   } else {
    //     this.getOptions(this.props.values[name]).then(response => {
    //       var defaultDict = response.options;

    //       var defalutValue = this.state.value ? defaultDict.find(obj => {
    //         return obj.Code == this.state.value
    //       }) : undefined;

    //       if (!defalutValue)
    //         this.props.values[name] = defalutValue;
    //       this.setState({});
    //     })
    //   }
    // };
  }


  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }


  // toggleTooltip = () => {
  //   if (!this.props.showTooltip) return;
  //   if (!this.state.value && !this.state.isToolTipOpen) return;

  //   console.log("this.nameInput.select: ", this.nameInput.select)
  //   if (this.nameInput.select.state.isOpen){
  //     this.setState({ isToolTipOpen: false })
  //     return;
  //   }
  //   console.log("toggleTooltip")
  //   // if ((!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view')))
  //   // this.setState(state => { !state.isToolTipOpen })
  //   // if (this.state.value && this.props.showTooltip)
  //   this.setState({ isToolTipOpen: !this.state.isToolTipOpen });
  // }


  render() {
    //////console.log(`async select ${this.props.name}`);
    //////console.log(this.cache);
    // console.log('selectDict', selectDict)

    const {
      tableName,
      name,
      values, errors, validateFieldValue, isSubmitted, formComponents,
      label,
      setFieldValue,
      setFieldTouched,
      getFormData,
      disabled,
    } = this.props;



    var value = this.state.value || '';
    const error = isSubmitted ? this.state.error : '';

    //update label 
    //var labelValue = this.state.label = this.getLabel(value, values[label]);
    var labelValue = this.state.label = this.getLabel(value);

    var selectedValue = {
      value: value,
      label: labelValue
    };

    //cache
    // var cache;
    // if (this.props.createAble) {
    //   cache = undefined;
    // } else {
    //   cache = this.cache;
    // }

    return (
      <div className={error && "is-invalid"}
        title={labelValue}
        id={"Tooltip-" + this.nameIndex}>
        <Async
          clearable={this.props.clearable}
          tabIndex={this.props.tabIndex}
          cache={this.cache}
          ignoreCase={false}
          ref={(input) => {
            this.nameInput = input;
          }}
          // filterOptions={(options, filter, current_values) => { return options; }}
          filterOption={() => (true)}
          loadOptions={debounce(this.getOptions, 300)}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={selectedValue}
          searchable={!this.props.notSearchable}
          disabled={!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view') || this.props.disabled}
          inputProps={this.props.inputProps}
          onInputChange={(value) => {
            // if (upperCaseOnly) value = value.toUpperCase();

            // value = this.toASCII(value);

            value =
              value.length <= this.maxLength
                ? value
                : value.substring(0, this.maxLength);

            return value;
          }}
        />
        {/* {(!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view')) && */}
        {/* <Tooltip
          placement='bottom'
          isOpen={this.state.isToolTipOpen}
          target={"Tooltip-" + this.nameIndex}
          autohide={false}
          toggle={this.toggleTooltip}
        >
          {labelValue}
        </Tooltip> */}
        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class NativeSelectField extends React.Component {

  constructor(props) {
    super(props);

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);
    this.shouldUpdate = false;

    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      data: []
    }
  }

  //==== End


  getFilter() {
    // ////console.log(filterKeys);
    let filterKeys = this.props.filterKeys || [];
    let values = this.props.values;
    var filter = {};
    filterKeys.forEach(key => {
      filter[key] = values[key];
    });
    return filter;

  }

  handleChange = (event, par1, par2) => {


    var label;
    var selectedValue = event.target.value;
    this.state.data.forEach(item => {
      if (item.Code == event.target.value) {
        label = item.Desc;
        return false;
      }
    });

    var value = {
      value: selectedValue,
      label: label,
    };

    //alert(JSON.stringify(value));


    if (this.props.setFieldValue) {
      this.props.setFieldValue(this.props.name, value.value, this.props.index, value.label);
      this.setState({ value: value.value });
    }

    if (this.props.onChange)
      this.props.onChange(value);

  };

  // handleBlur = (event) => {

  //   if (this.props.onBlur) {
  //     this.props.onBlur();



  //   }
  // };

  shouldComponentUpdate(nextProps, nextState) {


    var shouldUpdate = this.shouldUpdate;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];


    if (shouldUpdate) {
      this.shouldUpdate = false;
      return true;
    }

    ////console.log("================", shouldUpdate);

    return shouldUpdate;
  }


  updateLabel = () => {

    //////console.log("start updateLabel");
    var tableName = this.props.tableName;
    var value = this.state.value;

    if (!value
      || (selectDict[tableName][value] && this.state.label == selectDict[tableName][value].label)) return;

    this.shouldUpdate = true;
    this.setState({});
    //////console.log("updateLabel end");
  }

  getLabel(value) {
    var defaultLabel = this.props.placeholder || "Please select";
    var label = LabelMapping[defaultLabel] || defaultLabel;
    var tableName = this.props.tableName;

    if (value
      && selectDict[tableName]
      && selectDict[tableName][value]) {
      label = selectDict[tableName][value].label;
    }
    else if (value && this.props.label) {
      label = this.props.values[this.props.label];
    }


    return label;
  }

  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();

    getGeneralMaster("", this.props.module, this.props.tableName, this.props.name, this.props.label, this.props.createAble, this.updateLabel, this.getFilter()).then(data => {

      ////console.log("data================", data);
      this.shouldUpdate = true;
      this.setState({
        data: data.options
      });

    });
  }


  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }

  render() {

    ////console.log("render");

    const {
      tableName,
      multi,
      name,
      values, errors, validateFieldValue, isSubmitted, formComponents,
      label,
      setFieldValue,
      setFieldTouched,
      getFormData,
      disabled
    } = this.props;



    var value = this.state.value || '';
    const error = isSubmitted ? this.state.error : '';

    // var labelValue = this.state.label = this.getLabel(value);

    // var selectedValue = {
    //   value: value,
    //   label: labelValue
    // };

    return (

      <div className={error && "is-invalid"}>

        <select className="form-control"
          ref={(input) => {
            this.nameInput = input;
          }}
          onChange={this.handleChange}
          value={value}
          disabled={!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view')}
        >
          {this.state.data.map((obj, index) => (<option key={index} value={obj.Code}>{obj.Desc}</option>))}
        </select>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

//--test start
// const ChevronDown = () => (
//   <Svg style={{ marginRight: -6 }}>
//     <path
//       d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
//       fill="currentColor"
//       fillRule="evenodd"
//     />
//   </Svg>
// );

// const DropdownIndicator = () => (
//   <div css={{ color: colors.neutral20, height: 24, width: 32 }}>
//     <Svg>
//       <path
//         d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
//         fill="currentColor"
//         fillRule="evenodd"
//       />
//     </Svg>
//   </div>
// );
// const Dropdown = ({ children, isOpen, target, onClose }) => (
//   <div css={{ position: 'relative' }}>
//     {target}
//     {isOpen ? <Menu>{children}</Menu> : null}
//     {isOpen ? <Blanket onClick={onClose} /> : null}
//   </div>
// );

// const Svg = p => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     focusable="false"
//     role="presentation"
//     {...p}
//   />
// );
// const Menu = props => {
//   const shadow = 'hsla(218, 50%, 10%, 0.1)';
//   return (
//     <div
//       css={{
//         backgroundColor: 'white',
//         borderRadius: 4,
//         boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
//         marginTop: 8,
//         position: 'absolute',
//         zIndex: 2,
//       }}
//       {...props}
//     />
//   );
// };

// const Blanket = props => (
//   <div
//     css={{
//       bottom: 0,
//       left: 0,
//       top: 0,
//       right: 0,
//       position: 'fixed',
//       zIndex: 1,
//     }}
//     {...props}
//   />
// );

// const selectStyles = {
//   control: provided => ({ ...provided, minWidth: 240, margin: 8 }),
//   menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
// };
//-test end

export class MobilePopupList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isModalOpen: false
    }
  }

  toggleOpen = data => {
    this.setState({
      data: data || [],
      isModalOpen: !this.state.isModalOpen
    })
  }

  updateData = data => {
    this.setState({
      data: data
    })
  }

  render() {
    const { header, footer, listOnClick, focusInput } = this.props;
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        toggle={() => this.toggleOpen()}
        className="mobilePopupList"
        onOpened={() => {
          setTimeout(focusInput, 1000);
          // focusInput();
        }}
      >
        {header && <ModalHeader className="pr-0" style={{ display: 'block' }}>
          {header}
        </ModalHeader>}

        <ModalBody className="p-0">
          <ListGroup>
            {this.state.data.map(option => {
              return <ListGroupItem onClick={() => listOnClick(option)}>
                {option.label}</ListGroupItem>
            })}
          </ListGroup>
          {!this.state.data.length && <div className="ErrorMessage">
            <Label>Oops! No Record Found</Label>
          </div>}
        </ModalBody>
        {footer && <ModalFooter>
          {footer}
        </ModalFooter>}
      </Modal>
    );
  }
}



export class MobileSelectField extends React.Component {
  constructor(props) {
    super(props);
    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);
    this.shouldUpdate = false;

    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      isModalOpen: false,
      data: []
    }

    this.focusInput = this.focusInput.bind(this);
  }

  //Code to clear the cache==== Start
  cache = {}
  purgeCache = () => {

    Object.keys(this.cache).forEach(entry => {
      // //console.log("entry",entry);
      // //console.log("this.cache[entry]",this.cache[entry]);
      // //console.log("this.cache",this.cache);
      // //console.log("selectDict", selectDict);
      delete this.cache[entry]
    })

    // this.nameInput.loadOptions("");
  }
  //==== End

  handleChange = (value, par1, par2) => {

    value = value || {
      value: undefined,
      label: undefined,
    };


    if (this.props.getFormData) {
      this.state = {};
      var filterValues = {};
      if (this.props.filterKeys)
        this.props.filterKeys.forEach(x => {
          filterValues[x] = this.props.values[x];
        });
      this.props.getFormData({ ...filterValues, Code: value.value, [this.props.name]: value.value });
    } else {
      if (this.props.setFieldValue) {
        this.props.setFieldValue(this.props.name, value.value, this.props.index, value.label);
      }

      this.setState(value);

    }

    if (this.props.onChange)
      this.props.onChange(value);
  };

  getFilter() {
    // ////console.log(filterKeys);
    let filterKeys = this.props.filterKeys || [];
    let values = this.props.values;
    var filter = {};
    filterKeys.forEach(key => {
      filter[key] = values[key];
    });
    return filter;
  }

  handleBlur = (event) => {
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    //clear cache
    if (nextProps.isAfterSave && nextProps.isAfterSave()) {
      this.purgeCache();
    }

    var shouldUpdate = this.shouldUpdate;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }

    else if (this.state.isModalOpen != nextState.isModalOpen) {
      shouldUpdate = true;
    }
    else if (this.state.data != nextState.data)
      shouldUpdate = true;

    nextState.error = nextProps.errors[this.nameIndex];

    if (shouldUpdate) {
      this.shouldUpdate = false;
      return true;
    }
    return true;
  }

  getOptions = (input) => {

    return getGeneralMaster(input, this.props.module, this.props.tableName, this.props.name, this.props.label, this.props.createAble, this.updateLabel, this.getFilter(), this.props.localData).then(response => {
      // console.log(response);
      return response;
    });
  }


  getMobileOptions = (e) => {
    console.log(this.searchInput);
    console.log(this.nameInput);
    var input = this.searchInput.value;
    return getGeneralMaster(input, this.props.module, this.props.tableName, this.props.name, this.props.label, this.props.createAble, this.updateLabel, this.getFilter(), this.props.localData)
      .then(response => {
        console.log(response);

        if (this.nameInput)
          if (response.options) this.nameInput.updateData(response.options);

        return response;
      });
  }

  updateLabel = () => {

    //////console.log("start updateLabel");
    var tableName = this.props.tableName;
    var value = this.state.value;

    if (!value || !tableName
      || (selectDict[tableName][value] && this.state.label == selectDict[tableName][value].label)) return;

    this.shouldUpdate = true;
    this.setState({});
    //////console.log("updateLabel end");
  }

  getLabel(value) {
    var defaultLabel = this.props.placeholder || "Please select";
    var label = LabelMapping[defaultLabel] || defaultLabel;
    var tableName = this.props.tableName;

    if (value
      && selectDict[tableName]
      && selectDict[tableName][value]) {
      label = selectDict[tableName][value].label;
    }
    else if (value && this.props.label) {
      label = this.props.values[this.props.label];
    }

    return label;
  }

  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();

  }


  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }

  toggleOpen = () => {
    // if (this.customSelectField) console.log('this.customSelect: ', this.customSelectField)
    if (this.nameInput) {
      if (!this.nameInput.state.isModalOpen)
        this.fetchOption('', option => {
          console.log('fetchOption: ', option)
          this.nameInput.toggleOpen(option);
        })
      else
        this.nameInput.toggleOpen();
    }
    // console.log('this.state ', this.state)
    // // this.setState(state => ({ isOpen: !state.isOpen }));

    // // let fetchPromise = Promise.resolve(this.getOptions()).then(result => {
    // //   console.log('fetchPromise: ', result);
    // //   this.setState({
    // //     isModalOpen: !this.state.isModalOpen,
    // //     data: result.options
    // //   })
    // // })
    // if (!this.state.isModalOpen)
    //   this.fetchOption('', option => {
    //     console.log('fetchOption: ', option);
    //     this.setState({
    //       isModalOpen: !this.state.isModalOpen,
    //       data: option
    //     })
    //   })
    // else
    //   this.setState({ isModalOpen: !this.state.isModalOpen })
  };

  fetchOption = (input, callback) => {
    this.getOptions(input).then(result => {
      console.log('fetchPromise: ', result)
      if (result.options) callback(result.options);
    })
  }


  selectOption = option => {
    this.handleChange(option);
    this.nameInput.toggleOpen();
  }

  focusInput() {
    if (this.searchInput) {
      this.searchInput.focus();
      this.searchInput.click();
      this.setState({});
    }

  }

  render() {
    //////console.log(`async select ${this.props.name}`);
    //////console.log(this.cache);
    // console.log('selectDict', selectDict)

    const {
      tableName,
      name,
      values, errors, validateFieldValue, isSubmitted, formComponents,
      label,
      setFieldValue,
      setFieldTouched,
      getFormData,
      disabled,
    } = this.props;


    var value = this.state.value || '';
    const error = isSubmitted ? this.state.error : '';

    //update label 
    //var labelValue = this.state.label = this.getLabel(value, values[label]);
    var labelValue = this.state.label = this.getLabel(value);

    var selectedValue = {
      value: value,
      label: labelValue
    };

    var isDisable = !this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view');

    //cache
    // var cache;
    // if (this.props.createAble) {
    //   cache = undefined;
    // } else {
    //   cache = this.cache;
    // }

    return (
      <div className={error ? "mobile-select is-invalid" : "mobile-select"}
        // <div className={error && "is-invalid"}
        onClick={() => { if (!isDisable) this.toggleOpen() }}
      >
        <Async
          clearable={this.props.clearable}
          tabIndex={this.props.tabIndex}
          cache={this.cache}
          ignoreCase={false}
          className={selectedValue.value && "mobile-select-wrapper"}
          // ref={(input) => {
          //   this.customSelectField = input;
          // }}
          // filterOptions={(options, filter, current_values) => { return options; }}
          filterOption={() => (true)}
          loadOptions={debounce(this.getOptions, 300)}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={selectedValue}
          searchable={false}
          openOnClick={false}
          menuContainerStyle={{ display: 'none' }}
          inputRenderer={() => null}
          disabled={isDisable}
        />
        {/* <TextField
          {...this.props}
          mode='view'
        /> */}
        <MobilePopupList
          ref={input => {
            this.nameInput = input;
          }}
          header={
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ background: 'none', borderRight: 0 }}><i className="fa fa-search" /></InputGroupText>
              </InputGroupAddon>
              <Input
                // ref={input => this.searchInput = input}
                innerRef={input => this.searchInput = input}
                // onChange2={e => {
                //   debounce(this.fetchOption(e.target.value, option => {
                //     if (this.nameInput) this.nameInput.updateData(option);
                //     // this.setState({ data: option })
                //   }), 500)

                // }}

                onChange={debounce(this.getMobileOptions, 300)}
              // autoFocus={true}
              />
              <InputGroupAddon addonType="append">
                <Button className="noshadow" color="transparent" onClick={this.toggleOpen}>
                  <span style={{ color: '#339dd2', fontWeight: 600 }}><Label>Cancel</Label></span>
                </Button>
              </InputGroupAddon>
            </InputGroup>
          }
          listOnClick={this.selectOption}
          focusInput={this.focusInput}
        >
        </MobilePopupList>
        {/* <Async
          clearable={this.props.clearable}
          tabIndex={this.props.tabIndex}
          cache={this.cache}
          ignoreCase={false}
          ref={(input) => {
            this.nameInput = input;
          }}
          // filterOptions={(options, filter, current_values) => { return options; }}
          filterOption={() => (true)}
          loadOptions={debounce(this.getOptions, 300)}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={selectedValue}
          searchable={!this.props.notSearchable}
          disabled={!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view')}
        />

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )} */}
      </div>
    );
  }
}
// export class CheckboxField2 extends React.Component {

//   constructor(props) {
//     super(props);

//     var name = props.name;
//     var index = props.index;
//     this.nameIndex = getFieldIndex(name, index);

//     this.state = {
//       value: props.values[name],
//       error: props.errors[this.nameIndex],
//     }
//     this.MasterData = [];


//     this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
//   }

//   onRadioBtnClick(value) {

//     var name = this.props.name;
//     if (this.props.disableds[name]) return;

//     if (this.props.setFieldValue)
//       this.props.setFieldValue(name, value, this.props.index);

//     this.setState({ value });
//   }

//   focus() {
//     this.nameInput.focus();
//   }

//   shouldComponentUpdate(nextProps, nextState) {

//     var shouldUpdate = false;
//     var name = nextProps.name;
//     var index = nextProps.index;
//     this.nameIndex = getFieldIndex(name, index);




//     //internal update
//     if (nextState.value != this.state.value)
//       shouldUpdate = true;

//     //props update
//     else if (this.state.value != nextProps.values[name]) {
//       shouldUpdate = true;
//       nextState.value = nextProps.values[name];
//     }

//     else if (this.props.mode != nextProps.mode) {
//       shouldUpdate = true;
//     }

//     //validation update
//     else if (nextProps.errors.hasOwnProperty(this.nameIndex)
//       && (this.state.error != nextProps.errors[this.nameIndex]
//         || this.props.isSubmitted != nextProps.isSubmitted)) {
//       shouldUpdate = true;
//     }

//     else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
//       shouldUpdate = true;
//       this.state.disabled = nextProps.disableds[this.nameIndex];
//     }

//     nextState.error = nextProps.errors[this.nameIndex];
//     return shouldUpdate;
//   }

//   componentDidMount() {
//     let name = this.props.name;
//     let index = this.props.index;
//     let fieldIndex = getFieldIndex(name, index);
//     if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;
//     const { tableName } = this.props

//     if (this.props.autoFocus)
//       this.nameInput.focus();

//     if (selectDict[tableName]) {
//       this.MasterData = [];
//       for (var key in selectDict[tableName]) {
//         if (key && selectDict[tableName][key])
//           this.MasterData.push(selectDict[tableName][key]);
//       }
//       this.forceUpdate();
//     } else {

//       getGeneralMaster("", this.props.module, tableName, this.props.name, this.props.label).then((response) => {
//         ////console.log(response);
//         this.MasterData = response.options;
//         this.forceUpdate();
//       })
//     }

//   }

//   componentWillUnmount() {

//     // let name = this.props.name;
//     // let index = this.props.index;
//     // let fieldIndex = getFieldIndex(name, index);
//     // if(this.props.formComponents ) delete this.props.formComponents[fieldIndex];

//   }

//   render() {


//     const { tableName, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props


//     const value = this.state.value || '';

//     const error = isSubmitted ? this.state.error : '';

//     return (

//       <div className={error && "is-invalid"}>

//         <div ref={(input) => { this.nameInput = input; }} tabIndex={0} style={{ outline: 'none' }}>

//           <ButtonGroup>
//             {
//               this.MasterData.map((keyvalue) => {
//                 return (
//                   <Button color="primary" key={keyvalue.Code}
//                     onClick={() => {
//                       this.onRadioBtnClick(keyvalue.Code);
//                       if (this.props.onClick)
//                         this.props.onClick();
//                     }}
//                     active={this.state.value === keyvalue.Code}>
//                     {this.state.value === keyvalue.Code && <i className="fa fa-check"></i>}{" "} {keyvalue.Desc}
//                   </Button>
//                 );
//               })
//             }

//           </ButtonGroup>

//         </div>

//         {error &&
//           (
//             <div className="message">
//               {error}
//             </div>
//           )}
//       </div>
//     );
//   }
// }


export class CheckboxField extends React.Component {

  constructor(props) {
    super(props);

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);

    this.state = {
      // value: props.values[name],
      // error: props.errors[this.nameIndex],
    }

    this.containerWidth = 0;

    this.defaultOption = [
      { value: 'Y', label: 'Yes' },
      { value: 'N', label: 'No' }
    ]
    // this.MasterData = [];
    this.MasterData = props.tableName ? [] : this.defaultOption;

  }


  shouldComponentUpdate(nextProps, nextState) {
    var name = this.props.name;
    // console.log('nextProps', nextProps.values[name])
    this.setValue(nextProps.values[name]);
    this.setCheckboxWidth();
    return false;
  }

  componentDidMount() {
    // console.log("test componentDidMount", this);
    const { tableName } = this.props;
    var name = this.props.name;
    if (!this.props.tableName) {

      // this.MasterData = this.defaultOption;
      if (this.props.values[name]) {
        this.setValue(this.props.values[name]);
        this.forceUpdate();
      }
    }
    else {
      if (selectDict[tableName]) {
        this.MasterData = [];
        for (var key in selectDict[tableName]) {
          if (key && selectDict[tableName][key])
            this.MasterData.push(selectDict[tableName][key]);
        }
        this.forceUpdate();
      } else {

        getGeneralMaster("", this.props.module, tableName, this.props.name, this.props.label).then((response) => {
          ////console.log(response);
          this.MasterData = response.options;
          this.forceUpdate();
        })
      }
    }

  }

  setCheckboxWidth() {
    if (this.containerWidth == 0) {
      if (!this.option1 || !this.option2 || !this.container) return;
      var optionWidth = Math.max(this.option1.offsetWidth, this.option2.offsetWidth);
      console.log('optionWidth', optionWidth);


      this.option1.style.width = optionWidth + 'px';
      this.option2.style.width = optionWidth + 'px';

      this.containerWidth = optionWidth + 13;

      this.forceUpdate();
    }
  }

  componentWillUnmount() {


  }

  toggle = () => {
    var name = this.props.name;
    if (this.props.disableds[name] || this.props.mode == 'view') return;
    // console.log('toggle');

    // console.log('this.value', this.value);
    if (!this.props.tableName && (!this.value || this.value == ''))
      this.value = 'N';
    var currentValueIndex = this.MasterData.findIndex(x => x.value === this.value);
    // console.log('this.MasterData', this.MasterData)
    // console.log('currentValueIndex', currentValueIndex)
    var value;
    if (currentValueIndex == 1) {
      value = this.MasterData[0].value;
    } else {
      value = this.MasterData[1].value;
    }
    // if (this.value === "Y") {
    //   value = "N";
    // } else {
    //   value = "Y";
    // }

    this.setValue(value);

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, this.value, this.props.index);

    if (this.props.onClick)
      this.props.onClick();
  }

  setValue = (value) => {
    // console.log("test try setValue", value);
    // console.log('this.value', this.value)
    var name = this.props.name;

    if (this.value === value) return;

    this.value = value;

    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
      this.timeoutID = undefined;
    }

    if (!this.container) return;
    this.container.classList.add("animated");

    // if (this.value !== "Y") {
    if (this.value !== this.MasterData[0].value) {
      this.container.classList.remove("switchSlideInLeft");
      this.container.classList.add("switchSlideInRight");

    } else {
      this.container.classList.remove("switchSlideInRight");
      this.container.classList.add("switchSlideInLeft");
    }

    if (!this.timeoutID)
      this.timeoutID = setTimeout(() => {
        console.log("remove animation");
        this.container.classList.remove("animated");

      }, 250);



    // console.log("test success to setValue", this.value);

  }

  render() {
    // console.log("test render", this.value);
    const { tableName, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props

    // this.value = this.state.value || '';

    const error = isSubmitted ? this.state.error : '';
    if (!this.MasterData || this.MasterData.length == 0) return "";


    console.log(`this.props.name [${this.props.name}]: `, this.MasterData);
    return (

      <div className={error && "is-invalid"}>
        <div
          style={{ width: this.containerWidth }}
          className='switchContainer'
          onClick={this.toggle}
        >

          <div
            ref={input => this.container = input}
            className={`insideContainer noSelect`} >

            <span ref={input => this.option1 = input} className='bg-primary switchOption' ><Label>{this.MasterData[0].label}</Label></span>
            <span className="switchBar"></span>
            <span ref={input => this.option2 = input} className='text-center switchOption bg-gray-100' style={{ color: "#151b1e" }} ><Label>{this.MasterData[1].label}</Label></span>

            {/* <span className='bg-primary' ><Label>Yes</Label></span>
            <span className="switchBar"></span>
            <span className='text-center bg-gray-100' ><Label>No</Label></span> */}

          </div>

        </div>
        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class RadioField extends React.Component {

  constructor(props) {
    super(props);

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);

    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
    }
    this.MasterData = [];


    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
  }

  onRadioBtnClick(value) {

    var name = this.props.name;
    if (this.props.disableds[name]) return;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, value, this.props.index);

    this.setState({ value });
  }

  focus() {
    this.nameInput.focus();
  }

  handleChange = (value) => {
    if (this.props.onChange)
      this.props.onChange(value);
  };

  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);




    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }

    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }

    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;
  }

  componentDidMount() {
    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;
    const { tableName } = this.props

    if (this.props.autoFocus)
      this.nameInput.focus();

    if (selectDict[tableName]) {
      this.MasterData = [];
      for (var key in selectDict[tableName]) {
        if (key && selectDict[tableName][key])
          this.MasterData.push(selectDict[tableName][key]);
      }
      this.forceUpdate();
    } else {

      getGeneralMaster("", this.props.module, tableName, this.props.name, this.props.label).then((response) => {
        ////console.log(response);
        this.MasterData = response.options;
        this.forceUpdate();
      })
    }

  }

  componentWillUnmount() {

    // let name = this.props.name;
    // let index = this.props.index;
    // let fieldIndex = getFieldIndex(name, index);
    // if(this.props.formComponents ) delete this.props.formComponents[fieldIndex];

  }

  render() {


    const { tableName, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props


    const value = this.state.value || '';

    const error = isSubmitted ? this.state.error : '';

    return (

      <div className={error && "is-invalid"}>

        <div ref={(input) => { this.nameInput = input; }} tabIndex={0} style={{ outline: 'none' }}>

          <ButtonGroup>
            {
              this.MasterData.map((keyvalue) => {
                var isActive = this.state.value === keyvalue.Code;
                return (
                  <Button color={"light"} key={keyvalue.Code}
                    onClick={() => {
                      this.onRadioBtnClick(keyvalue.Code);
                      this.handleChange(keyvalue.Code);
                      if (this.props.onClick)
                        this.props.onClick();
                    }}
                    outline={true}
                    active={isActive}
                    disabled={!this.props.getFormData && (this.props.disableds[this.nameIndex] || this.props.mode == 'view')}
                  >
                    {this.state.value === keyvalue.Code && <i className="fa fa-check"></i>}{" "} {keyvalue.Desc}
                  </Button>
                );
              })
            }

          </ButtonGroup>

        </div>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class DateTimeField extends React.Component {

  constructor(props) {
    super(props);

    this.format = "DD/MM/YYYY";
    this.timeFormat = "hh:mm A";
    this.dateTimeLengh = 19;








    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);







    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      isInternal: false,
    }














  }


  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus && this.nameInput)
      this.nameInput.focus();



  }

  handleChange = event => {
    //////console.log("handleChange");


    var text = "";
    if (event) {
      if (event._isValid)
        text = event.format("DD/MM/YYYY HH:mm:ss");
      else
        text = moment().format("DD/MM/YYYY HH:mm:ss");
    }

    this.isInternal = true;
    this.setState({
      value: text
    });


  };

  handleBlur(event) {
    ////console.log("handleBlur");

    var name = this.props.name;
    var text = '';
    if (event) {
      if (event._isValid)
        text = event.format("DD/MM/YYYY HH:mm:ss");
    }

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);




    if (this.props.errors.hasOwnProperty(name))
      this.setState({});
  };










  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);










    //internal update
    if (this.isInternal || nextState.value != this.state.value) {
      shouldUpdate = true;
      this.isInternal = false;
    }



    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;
  }


  renderInput = props => {
    return (
      <div>
        <input ref={(input) => {
          this.nameInput = input;


        }}  {...props} disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view'} />
      </div>
    );
  }


  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }

  render() {

    //////console.log(`render ${this.props.name} ${this.state.value}`);

    const { setFieldValue, setFieldTouched, closeOnTab, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, disableDatePicker, ...restProps } = this.props



    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;



    var value;

    if (this.state.value
      && this.state.value.length == 19) {
      //value = moment(this.state.value, this.format + " HH:mm:ss").format(`${this.format} ${this.timeFormat}`);; 
      value = moment(this.state.value, this.format + " HH:mm:ss");
    } else {
      value = this.state.value = '';
    }

    const error = isSubmitted ? this.state.error : '';

    return (

      <div className={error && "is-invalid"}>

        <div className="input-group">

          <DateTime input={true} closeOnTab={closeOnTab || true} dateFormat={disableDatePicker ? false : this.format} timeFormat={this.timeFormat}

            renderInput={this.renderInput}
            value={value} disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view'}
            onChange={this.handleChange}
            onBlur={event => {
              this.handleBlur(event)
            }}
            inputProps={restProps}

          />

          <div className="input-group-append">
            <span className="input-group-text"><i className="fa fa-calendar"></i></span>
          </div>
        </div>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>

    );
  }
}

export class DateField extends React.Component {
  render() {
    var useNative = (window.isTablet);

    if (useNative)
      return (<NativeDateField {...this.props}></NativeDateField>);
    else
      return <HTMLDateField {...this.props} ></HTMLDateField>;
  }

}

export class NativeDateField extends React.Component {

  constructor(props) {
    super(props);

    this.format = "DD/MM/YYYY";

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);


    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      isInternal: false,
    }
  }


  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();
  }


  handleChange = event => {
    //console.log("==================handleChange");


    const target = event.nativeEvent.target;
    var name = this.props.name;
    var text = '';
    if (event) {
      if (event._isValid)
        text = event.format("DD/MM/YYYY HH:mm:ss");
      else if (event.target.value) {
        text = moment(event.target.value, "YYYY-MM-DD").format("DD/MM/YYYY HH:mm:ss");
      }
    }

    if (text == "01/01/0001 00:00:00")
      text = "";

    this.isInternal = true;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    logMessageToChatRoom(text);
    logMessageToChatRoom("==============");
    target.value = undefined;
    this.setState({
      value: text
    });

    var iosClearDefault = () => {
      let date = this.getDateFromText(text);
      target.defaultValue = date;
      // target.value = date ;
    }
    window.setTimeout(iosClearDefault);

    if (this.props.onChange)
      this.props.onChange(event);

  };

  getDateFromText = (text) => {

    var value;

    if (text
      && text.length >= 10) {
      value = moment(this.state.value, this.format + " HH:mm:ss");
    } else {
      value = this.state.value = '';
    }
    return value;
  }

  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (this.isInternal || nextState.value != this.state.value) {
      shouldUpdate = true;
      this.isInternal = false;
    }

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;

  }

  focus() {
    this.nameInput.focus();
  }

  render() {

    const { setFieldValue, setFieldTouched, closeOnTab, closeOnSelect, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props

    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;

    var value = this.getDateFromText(this.state.value);

    const error = isSubmitted ? this.state.error : '';

    if (window.isTablet && value) {
      value = value.format("YYYY-MM-DD");
    }

    return (

      <div className={error && "is-invalid"}>

        <div className="input-group rdt">

          <input type='date' className="form-control" {...restProps}
            ref={(input) => {
              this.nameInput = input;
            }}
            value={value}
            onChange={event => {
              this.handleChange(event);
            }}
            disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view'}
          />

          <div className="input-group-append">
            <span className="input-group-text"><i className="fa fa-calendar"></i></span>
          </div>
        </div>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>

    );
  }
}

export class HTMLDateField extends React.Component {

  constructor(props) {
    super(props);

    this.format = "DD/MM/YYYY";

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);


    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      isInternal: false,
    }
  }


  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();
  }


  handleChange = event => {
    //console.log("==================handleChange");

    const { withTime } = this.props;

    var format = !withTime ? "DD/MM/YYYY 00:00:00" : "DD/MM/YYYY HH:mm:ss";

    var name = this.props.name;
    var text = "";
    if (event) {
      if (event._isValid)
        text = event.format(format);
      else
        text = moment().format(format);
    }

    if (text == "01/01/0001 00:00:00")
      text = "";

    this.isInternal = true;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    this.setState({
      value: text
    });

    if (this.props.onChange)
      this.props.onChange(event);

  };

  handleBlur(event) {
    //console.log("==================handleBlur");

    var name = this.props.name;
    var text = '';
    if (event) {
      if (event._isValid)
        text = event.format("DD/MM/YYYY HH:mm:ss");
      else if (event.target.value) {
        text = moment(event.target.value, "YYYY-MM-DD").format("DD/MM/YYYY HH:mm:ss");
      }
    }
    ////console.log(text);
    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    if (this.props.errors.hasOwnProperty(name) || window.isTablet)
      this.setState({});

    if (window.isTablet) {
      const target = event.nativeEvent.target;
      var iosClearDefault = () => {
        target.defaultValue = '';
        // this.handleChange();
      }

      window.setTimeout(iosClearDefault, 0);
      // this.handleChange();
    }

  };

  inlineBlur = () => {
    //console.log("==================inlineBlur");
    if (this.props.onBlur) {
      setTimeout(() => {
        this.props.onBlur();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);





    //internal update
    if (this.isInternal || nextState.value != this.state.value) {
      shouldUpdate = true;
      this.isInternal = false;
    }

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name] != '01/01/0001 00:00:00' ? nextProps.values[name] : "";
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;

  }


  renderInput = props => {
    //console.log("Props", props)
    return (
      <div>
        <input ref={(input) => {
          this.nameInput = input;

        }} {...props} disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view'} />
      </div>
    );
  }

  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }

  render() {


    //////console.log(`render ${this.props.name} ${this.state.value}`);

    const { setFieldValue, setFieldTouched, closeOnTab, closeOnSelect, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props


    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;

    var name = this.props.name;



    var value = this.state.value || '';

    if (this.state.value
      && this.state.value.length >= 10) {
      //value = moment(this.state.value, this.format + " HH:mm:ss").format(`${this.format} ${this.timeFormat}`);; 
      value = moment(this.state.value, this.format + " HH:mm:ss");
    } else {
      value = this.state.value = '';
    }

    const error = isSubmitted ? this.state.error : '';

    if (window.isTablet && value) {
      value = value.format("YYYY-MM-DD");
    }
    //console.log(loginInfo); 
    return (

      <div className={error && "is-invalid"}>

        <div className="input-group">

          <DateTime input={true} closeOnTab={closeOnTab !== false} closeOnSelect={closeOnSelect !== false} dateFormat={this.format} timeFormat={false}
            tabIndex={this.props.tabIndex}
            renderInput={this.renderInput}
            value={value}
            onChange={this.handleChange}
            onBlur={this.inlineBlur}
            inputProps={restProps}
          />

          <div className="input-group-append">
            <span className="input-group-text"><i className="fa fa-calendar"></i></span>
          </div>
        </div>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>

    );
  }
}

export class PeriodField extends React.Component {

  constructor(props) {
    super(props);

    this.format = "DD/MM/YYYY";

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);


    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
      isInternal: false,
    }
  }


  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();
  }


  handleChange = event => {
    //////console.log("handleChange");

    var name = this.props.name;
    var text = "";
    if (event) {
      if (event._isValid)
        text = event.format("DD/MM/YYYY HH:mm:ss");
      else
        text = moment().format("DD/MM/YYYY HH:mm:ss");
    }

    if (text == "01/01/0001 00:00:00")
      text = "";

    this.isInternal = true;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    this.setState({
      value: text
    });

    if (this.props.onChange)
      this.props.onChange(event);

  };

  handleBlur(event) {

    //////console.log("handleBlur");

    var name = this.props.name;
    var text = '';
    if (event) {
      if (event._isValid)
        text = event.format("DD/MM/YYYY HH:mm:ss");
      else if (event.target.value) {
        text = moment(event.target.value, "YYYY-MM-DD").format("DD/MM/YYYY HH:mm:ss");
      }
    }
    ////console.log(text);
    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    if (this.props.errors.hasOwnProperty(name) || window.isTablet)
      this.setState({});

    if (window.isTablet) {
      const target = event.nativeEvent.target;
      function iosClearDefault() { target.defaultValue = ''; }
      window.setTimeout(iosClearDefault, 0);
    }

  };

  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);





    //internal update
    if (this.isInternal || nextState.value != this.state.value) {
      shouldUpdate = true;
      this.isInternal = false;
    }

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;

  }


  renderInput = props => {
    return (
      <div>
        <input ref={(input) => {
          this.nameInput = input;

        }} {...props} disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view'} />
      </div>
    );
  }

  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }

  render() {


    //////console.log(`render ${this.props.name} ${this.state.value}`);

    const { setFieldValue, setFieldTouched, closeOnTab, closeOnSelect, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props


    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;

    var name = this.props.name;
    var tmpCloseOnSelect = true;
    if (closeOnSelect === false) {
      tmpCloseOnSelect = false;
    }





    var value;

    if (this.state.value
      && this.state.value.length >= 10) {
      //value = moment(this.state.value, this.format + " HH:mm:ss").format(`${this.format} ${this.timeFormat}`);; 
      value = moment(this.state.value, this.format + " HH:mm:ss");
    } else {
      value = this.state.value = '';
    }

    const error = isSubmitted ? this.state.error : '';

    if (window.isTablet && value) {
      value = value.format("YYYY-MM-DD");
    }
    ////console.log(value); 
    return (

      <div className={error && "is-invalid"}>

        <div className="input-group">

          {window.isTablet ? <input type='date' className="form-control" {...restProps}
            ref={(input) => {
              this.nameInput = input;
            }}
            value={value}
            onChange={event => {
              this.handleBlur(event);
            }}
          /> :
            <DateTime input={true} closeOnTab={true} closeOnSelect={tmpCloseOnSelect} dateFormat={"MM/YYYY"} timeFormat={false}
              viewMode={"months"}
              renderInput={this.renderInput}
              value={value}
              onChange={this.handleChange}
              onBlur={event => {
                this.handleBlur(event);
              }}
              inputProps={restProps}
            />}

          <div className="input-group-append">
            <span className="input-group-text"><i className="fa fa-calendar"></i></span>
          </div>
        </div>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>

    );
  }
}

export class ColorField extends React.Component {

  constructor(props) {
    super(props);

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);

    this.state = {
      value: props.values[name],
    }
  }

  handleChange = event => {

    var text = event.currentTarget.value;
    this.setState({
      value: text
    });
    var name = this.props.name;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

  };

  focus() {
    this.nameInput.focus();
  }

  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    return shouldUpdate;
  }

  componentDidMount() {
    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();
  }

  componentWillUnmount() {
  }

  render() {

    const { Prefix, Suffix, multipleLine, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props

    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;

    const value = this.state.value || '';


    return (
      <input type="color"
        ref={(input) => { this.nameInput = input; }}
        {...restProps}
        onChange={this.handleChange}
        value={value}
      />
    );
  }
}

export class TextField extends React.Component {
  constructor(props) {
    super(props);


    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);

    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
    }

    this.maxLength = 524288;
  }

  handleChange = event => {
    var name = this.props.name;
    var text = event.currentTarget.value;

    var isValid = true;
    switch (this.props.datatype) {
      case "Number":
        //console.log("case Number")
        if (text && !/^([1-9][0-9]+|[0-9])(\.[0-9]*)?$/.test(text))
          isValid = false;
        break;
    }

    if (!isValid) return;

    //Added by Ning
    // //console.log("this.props.index", this.props.index);
    if (this.props.setFieldValue && this.props.index === undefined)
      this.props.setFieldValue(name, text, this.props.index);

    this.setState({
      value: text
    });

  };

  handleBlur = event => {
    var name = this.props.name;
    var text = event.currentTarget.value;

    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);

    if (this.props.errors.hasOwnProperty(name))
      this.setState({});

    if (this.props.onBlur)
      this.props.onBlur();
  };

  focus() {
    //////console.log(this);
    this.nameInput.focus();
  }

  shouldComponentUpdate(nextProps, nextState) {

    //////console.log(`Text field shouldComponentUpdate  ${this.props.name}`);



    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);




    //internal update
    if (nextState.value != this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value != nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }
    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }

    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }

    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;
  }

  componentDidMount() {
    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();
  }

  componentWillUnmount() {

    // let name = this.props.name;
    // let index = this.props.index;
    // let fieldIndex = getFieldIndex(name, index);
    // if(this.props.formComponents ) delete this.props.formComponents[fieldIndex];

  }

  render() {
    //////console.log(`render TextField ${this.props.name} ${this.state.value} ${this.state.error}`);

    const { Prefix, Suffix, multipleLine, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props

    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;

    const value = this.state.value || '';

    const error = isSubmitted ? this.state.error : '';

    var fieldLengthDict = window.fieldLengthDict;

    if (fieldLengthDict && fieldLengthDict[this.props.tableID] && fieldLengthDict[this.props.tableID][this.props.name]) {
      this.maxLength = fieldLengthDict[this.props.tableID][this.props.name];
    }

    return (




      <div className={error && "is-invalid"}>


        <div className="input-group">

          {Prefix &&
            (
              <Prefix></Prefix>
            )}

          {!multipleLine
            ? <input className="form-control" type="text"
              ref={(input) => { this.nameInput = input; }}
              onClick={selectAllContent}
              onFocus={selectAllContent}
              {...restProps}

              onChange={this.handleChange}
              onBlur={this.handleBlur}
              value={value} disabled={(this.props.disableds[this.nameIndex] || this.props.mode == 'view') && this.props.disabled !== false}
              maxLength={this.maxLength}
            />
            : <textarea className="form-control" type="text"
              ref={(input) => { this.nameInput = input; }}
              {...restProps}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              value={value} disabled={(this.props.disableds[this.nameIndex] || this.props.mode == 'view') && this.props.disabled !== false}
              maxLength={this.maxLength}
            />}

          {Suffix &&
            (
              <Suffix></Suffix>
            )}

        </div>

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class NumberField extends React.Component {
  constructor(props) {
    super(props);
    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);

    this.state = {
      value: props.values[name],
      error: props.errors[this.nameIndex],
    }
  }

  handleChange = event => {
    var text = event.currentTarget.value;

    // if (this.props.numberFormat == 'currency') {
    //   while (text.lastIndexOf(',') > 0)
    //     text = text.replace(',', "");
    // }

    if (this.props.allownegative) {
      if (text && (text != '-' && !/^\-?([1-9][0-9]+|[0-9])(\.[0-9]*)?$/.test(text))) return;
    }
    else if (this.props.integerOnly) {
      if (text && !/^(0|\+?[1-9]\d*)$/.test(text)) return;
    }
    else if (text && !/^([1-9][0-9]+|[0-9])(\.[0-9]*)?$/.test(text)) return;

    this.setState({
      value: text
    });

  };

  handleBlur = event => {
    var name = this.props.name;
    var text = event.currentTarget.value.replace(/\.$/g, '');
    if (text == '-')
      text = '';


    // var value = this.state.value.replace(/\.$/g, '');
    // if (value == '-') value = '';




    if (this.props.setFieldValue)
      this.props.setFieldValue(name, text, this.props.index);
    // this.props.setFieldValue(name, value, this.props.index);




    if (text != event.currentTarget.value
      || this.props.errors.hasOwnProperty(name))
      this.setState({});


    if (this.props.onBlur)
      this.props.onBlur();



  };






  focus() {
    //////console.log(this.nameInput);
    this.nameInput.focus();
  }


  shouldComponentUpdate(nextProps, nextState) {

    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    if (nextState.value !== this.state.value)
      shouldUpdate = true;

    //props update
    else if (this.state.value !== nextProps.values[name]) {
      shouldUpdate = true;
      nextState.value = nextProps.values[name];
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }
    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }
    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;
  }






  componentDidMount() {

    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;

    if (this.props.autoFocus)
      this.nameInput.focus();
  }
  render() {

    //////console.log(`render NumberField ${this.state.value}`);

    const { integerOnly, numberFormat, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, ...restProps } = this.props

    restProps.placeholder = LabelMapping[restProps.placeholder] || restProps.placeholder;

    const value = (this.state.value || this.state.value == 0) ? this.state.value : '';

    const error = isSubmitted ? this.state.error : '';


    return (

      <div className={error && "is-invalid"}>

        <input className="form-control text-right" type={window.isTablet ? "number" : "text"}

          ref={(input) => { this.nameInput = input; }}

          {...restProps}

          onClick={selectAllContent}
          onFocus={selectAllContent}

          onChange={this.handleChange}
          onBlur={this.handleBlur}
          // value={numberFormat == 'currency' ? toCurrency(value) : value} 
          value={value}
          disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view' || this.props.disabled}
        />

        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class FileField extends React.Component {
  constructor(props) {
    super(props);

    var name = props.name;
    var index = props.index;
    this.nameIndex = getFieldIndex(name, index);
    this.fileInput = React.createRef();
    this.state = {
      value: props.values[name],
      mode: props.filename ? 'display' : 'upload' || 'upload',
      filename: props.filename || '',
      error: props.errors[this.nameIndex],
    }
    this.fileObj = {};
    // this.handleChange = this.handleChange.bind(this);
  }

  handleChange = event => {
    //  ////console.log("handleChange", this.fileInput.current.files);
    //  ////console.log("handleChange", this.fileInput.current.files[0].name);

    console.log('this.fileInput.current.files: ', this.fileInput.current.files)

    if (this.fileInput.current.files.length >= 1) {
      var reader = new FileReader();
      reader.onload = (loadEvent) => {

        var fileArray = loadEvent.target.result.split(";base64,");
        var fileName = this.fileInput.current.files[0].name;
        this.fileObj.mime = fileArray[0].substring(5);
        this.fileObj.data = fileArray[1];
        this.fileObj.ext = fileName.substr(fileName.lastIndexOf('.'));

        if (this.props.callback) {
          this.props.callback({
            FileName: this.fileInput.current.files[0].name,
            FileSize: this.fileInput.current.files[0].size,
            MIME: this.fileObj.mime,
            FileExtension: this.fileObj.ext
          });
        }
        this.props.values[this.props.name] = this.fileObj.data;
        this.setState({
          filename: this.fileInput.current.files[0].name,
          mode: 'display',
        });
      }
      reader.readAsDataURL(this.fileInput.current.files[0]);
      // reader.readAsArrayBuffer(this.fileInput.current.files[0]);
      // reader.readAsText(this.fileInput.current.files[0]);
    }
  };

  // };
  focus() {
    ////console.log(this);
    this.fileInput.focus();
  }

  shouldComponentUpdate(nextProps, nextState) {

    //////console.log(`Text field shouldComponentUpdate  ${this.props.name}`);
    var shouldUpdate = false;
    var name = nextProps.name;
    var index = nextProps.index;
    this.nameIndex = getFieldIndex(name, index);

    //internal update
    for (var pro in this.state) {
      if (nextState[pro] != this.state[pro]) {
        shouldUpdate = true;
        break;
      }
    }
    console.log(nextState);
    console.log(this.state);

    console.log(nextProps);
    console.log(this.props);
    if (shouldUpdate) {

      if (nextState.fileName != this.state.filename && (nextState.mode == "upload" && this.state.mode == "display")) {
        if (this.props.callback) {
          this.props.callback({
            FileName: "",
            FileSize: 0,
            FilePath: "",
            // FileID: "",
            MIME: "",
            FileExtension: ""
          })
        }
        this.setState({
          filename: '',
          mode: 'upload'
        })
      }
    }
    //props update
    else if (this.props.fileID != nextProps.fileID) {
      shouldUpdate = true;
      // this.state.mode = (nextProps.filename != "" && nextProps.filename) ? "display" : "upload";
      // this.state.filename = (nextProps.filename != "" && nextProps.filename) ? nextProps.filename : '';
      this.setState({
        mode: (nextProps.filename != "" && nextProps.filename) ? "display" : "upload",
        filename: (nextProps.filename != "" && nextProps.filename) ? nextProps.filename : ''
      })
    }

    else if (this.props.filename != nextProps.filename) {
      shouldUpdate = true;
      // this.state.mode = (nextProps.filename != ""  && nextProps.filename) ? "display" : "upload";
      // this.state.filename = (nextProps.filename != "" && nextProps.filename) ? nextProps.filename : '';
      this.setState({
        mode: (nextProps.filename != "" && nextProps.filename) ? "display" : "upload",
        filename: (nextProps.filename != "" && nextProps.filename) ? nextProps.filename : ''
      })
    }

    else if (this.props.mode != nextProps.mode) {
      shouldUpdate = true;
    }

    //validation update
    else if (nextProps.errors.hasOwnProperty(this.nameIndex)
      && (this.state.error != nextProps.errors[this.nameIndex]
        || this.props.isSubmitted != nextProps.isSubmitted)) {
      shouldUpdate = true;
    }

    else if (this.state.disabled != nextProps.disableds[this.nameIndex]) {
      shouldUpdate = true;
      this.state.disabled = nextProps.disableds[this.nameIndex];
    }

    nextState.error = nextProps.errors[this.nameIndex];
    return shouldUpdate;
  }

  componentDidMount() {
    let name = this.props.name;
    let index = this.props.index;
    let fieldIndex = getFieldIndex(name, index);
    if (this.props.formComponents) this.props.formComponents[fieldIndex] = this;
    if (this.props.autoFocus)
      this.fileInput.focus();
  }

  componentDidUpdate() {

  }

  componentWillUnmount() {

    // let name = this.props.name;
    // let index = this.props.index;
    // let fieldIndex = getFieldIndex(name, index);
    // if(this.props.formComponents ) delete this.props.formComponents[fieldIndex];

  }
  render() {
    //console.log('filefield', this.props)
    //////console.log(`render TextField ${this.props.name} ${this.state.value} ${this.state.error}`);
    const { fileID, filename, category, Prefix, Suffix, multipleLine, setFieldValue, setFieldTouched, autoFocus, onChange, onBlur, isGetFormData, values, errors, validateFieldValue, isSubmitted, formComponents, callback, ...restProps } = this.props
    const value = this.state.value || '';
    const error = isSubmitted ? this.state.error : '';

    console.log("fileprops", this.props);

    var filePath;
    if (fileID) {
      filePath = `${window.host}/FB.FileDownload?p=1&p1=${fileID}&p2=${loginInfo.Session}`

      if (category) filePath += `&p3=${category}`;
      if (this.state.filename) filePath += `&p4=${this.state.filename}`;
    } else {
      filePath = 'javascript:void;';
    }

    return (
      <div className={error && "is-invalid"}>
        <div className="input-group">
          <input
            className="form-control"
            type="file"
            ref={this.fileInput}
            text="xd"
            style={{ display: (this.state.mode == 'display') ? "none" : 'block' }}
            {...restProps}
            onChange={this.handleChange}
          // onBlur={this.handleBlur}
          // value={value} 
          // disabled={this.props.disableds[this.nameIndex] || this.props.mode == 'view'}
          />
          {(this.state.mode == 'display') && <div
            className="form-control text-left"
          >
            {/* <a
              href={fileID ? `${window.host}/FB.FileDownload?p=1&p1=${fileID}&p2=${loginInfo.Session}&p3=${category ? category : ""}&p4=${this.state.filename ? this.state.filename : fileID}` : 'javascript:void;'}>
              {this.state.filename || 'View'}
            </a> */}

            <a href={filePath} target={this.state.filename ? "_self" : "_blank"}>
              {this.state.filename || 'View' + filePath}
            </a>

            <i className="fa fa-close pull-right"
              onClick={() => {
                this.setState({
                  filename: '',
                  mode: 'upload'
                });
                this.fileInput.current.value = null;
                // callback({
                //     FileName: "",
                //     FileSize: 0,
                //     MIME: "",
                //     FileExtension: ""
                //   })
              }}
              style={{ lineHeight: 1.5 }}></i></div>}
        </div>
        {error &&
          (
            <div className="message">
              {error}
            </div>
          )}
      </div>
    );
  }
}

export class DisplayJson extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    height: 10000
  }

  render() {

    var props = this.props;
    return "";
    // return (

    //   <div className="mt-1" style={{maxHeight: `${this.state.height}px`, overflow:'hidden'}} onClick={()=>{
    //     return;
    //     if(this.state.height == 10000)
    //       this.setState({height:35});
    //     else
    //       this.setState({height:10000});

    //   }}>
    //   <h3 style={{ fontFamily: 'monospace' }} />
    //   <pre
    //     style={{
    //       background: '#f6f8fa', 
    //       padding: '.5rem',
    //     }}
    //   > 
    //   //For debug only <br/> 
    //     {JSON.stringify(props, null, 2)}
    //   </pre>
    // </div>
    // );
  }
}

export class KioskTable extends React.Component {


  constructor(props) {
    super(props);
  }

  render() {

    ////console.log(this.props.data);
    ////console.log(this.props.columns);

    return (
      <table className="table">
        <tr>
          {this.props.columns.map(ele => {
            ////console.log(ele);
            if (ele.Header)
              return (<th>{ele.Header()}</th>);
            else return <th></th>;
          })}
        </tr>

        {this.props.data.map(obj => {
          return (<tr>
            {this.props.columns.map(ele => {
              ////console.log(ele);
              if (ele.Header)
                return (<td>
                  {obj[ele.accessor]}

                </td>);
              else return "";
            })}
          </tr>);
        })}

      </table>);
  }

}

export class DynamicLabel extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // ////console.log(this.props.children);
    // ////console.log(nextProps.children);
    return this.props.children != nextProps.children;
  }

  render() {

    return <Fragment>
      {LabelMapping[this.props.children] || this.props.children}
    </Fragment>
  }
}

export class Label extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {

    return <Fragment>
      {LabelMapping[this.props.children] || this.props.children}
    </Fragment>
  }
}

export class DraggableLabel extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { value, ...rest } = this.props;
    return <div {...rest} draggable={true} onDragStart={() => {
      loginInfo.dragData = this.props.value;
    }}
    >
      {this.props.children}
    </div>
  }
}

export class LanguageSelect extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {

    return <select className="form-control" defaultValue={loginInfo.language || getCookie("language")} onChange={(e) => {
      ////console.log(e.target);
      setLanguage(e.target.value, this.props.notUpdateServer);
    }}>
      <option value='eng' >English</option>
      <option value='cb5' >繁體中文</option>
    </select>
  }
}

export class LoadingButton extends React.Component {

  constructor(props) {
    super(props);
    this.loading = false;
    props.bindref(this);
  }

  shouldComponentUpdate(nextProps, nextState) {

    if (this.internalUpdate) {
      this.internalUpdate = false;
      return true;
    }

    return false;
  }

  componentWillUnmount() {
    this.willUnmount = true;
  }

  toggle = () => {
    if (this.willUnmount) return;
    this.internalUpdate = true;
    this.loading = !this.loading;
    this.setState({});
  }

  click = (e) => {
    if (this.loading) return;

    this.toggle();

    this.props.onClick(e).then(() => {
      this.toggle();
    });
  }

  render() {
    const { bindref, ...rest } = this.props;
    return <Button {...rest}
      disabled={this.loading}
      onClick={this.click}>{this.loading ? <i className="fa fa-spinner fa-spin"></i> : this.props.children}</Button>
  }

}

export class CollapsePanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCollpase: props.defaultOpen,
    }
  }

  render() {
    const { children, title } = this.props;

    return (
      <Card className="bg-light collapsePanel">
        <CardHeader className="collapse-bar" style={{ display: "block" }}
          onClick={() => this.setState({ isCollpase: !this.state.isCollpase })}>
          <Row>
            <Col xs="6" className="col-form-label">
              <Label>{title || ''}</Label>
            </Col>
            <Col xs="6" className="col-form-label" align="right">
              <i className={this.state.isCollpase ? "fa fa-angle-up" : "fa fa-angle-down"}
              ></i>
            </Col>
          </Row>
        </CardHeader>

        <Collapse isOpen={this.state.isCollpase} >
          <CardBody>
            {children}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

export class DynamicReactTable extends React.Component {
  render() {
    if (window.isTablet)
      return <MobileGrid {...this.props} />
    else
      return <ReactTable {...this.props} />
  }
}


// WEBPACK FOOTER //
// ./src/components/FormControl.js